var _defs, _g, _g2, _path, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92,
    height: 101,
    viewBox: "0 0 92 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4295",
    "data-name": "Rectangle 4295",
    width: 49,
    height: 64,
    transform: "translate(258 859)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c1c1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 0.686,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffaea"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32310",
    "data-name": "Group 32310",
    transform: "translate(-131 -824)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32309",
    "data-name": "Group 32309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M1667,2617h-24a12,12,0,0,1,24,0Z",
    transform: "translate(-1512 -1781)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4289",
    "data-name": "Rectangle 4289",
    d: "M0,0H56a8,8,0,0,1,8,8V88a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V0A0,0,0,0,1,0,0Z",
    transform: "translate(142 824)",
    fill: "url(#linear-gradient)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_32308",
    "data-name": "Group 32308"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_235",
    "data-name": "Ellipse 235",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(150 840)",
    fill: "#fffaea"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_490",
    "data-name": "Line 490",
    x2: 34,
    transform: "translate(164 843)",
    fill: "none",
    stroke: "#fffaea",
    strokeLinecap: "round",
    strokeWidth: 2,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_236",
    "data-name": "Ellipse 236",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(150 852)",
    fill: "#fffaea"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_491",
    "data-name": "Line 491",
    x2: 34,
    transform: "translate(164 855)",
    fill: "none",
    stroke: "#fffaea",
    strokeLinecap: "round",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_492",
    "data-name": "Line 492",
    x2: 34,
    transform: "translate(164 863)",
    fill: "none",
    stroke: "#fffaea",
    strokeLinecap: "round",
    strokeWidth: 2,
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_32243",
    "data-name": "Mask Group 32243",
    transform: "translate(-84 2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32307",
    "data-name": "Group 32307",
    transform: "translate(79.785 -10.39)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4292",
    "data-name": "Rectangle 4292",
    d: "M0,0H10a0,0,0,0,1,0,0V19a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V0A0,0,0,0,1,0,0Z",
    transform: "translate(188.67 908.605) rotate(30)",
    fill: "#fc3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32306",
    "data-name": "Group 32306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4293",
    "data-name": "Rectangle 4293",
    d: "M0,0H10a0,0,0,0,1,0,0V19a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V0A0,0,0,0,1,0,0Z",
    transform: "translate(188.67 908.605) rotate(30)",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    transform: "translate(194.215 861) rotate(30)",
    stroke: "#fc3",
    strokeWidth: 4,
    fill: "url(#linear-gradient-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22,
    fill: "none"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34068",
    "data-name": "Group 34068",
    transform: "translate(765.767 274.712) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_494",
    "data-name": "Line 494",
    y2: 23,
    transform: "translate(40 824)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_495",
    "data-name": "Line 495",
    y2: 23,
    transform: "translate(51.5 835.5) rotate(90)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeWidth: 3
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEmpty);
export default __webpack_public_path__ + "static/media/search-empty.55590c19ad6777de0871d945943e37e0.svg";
export { ForwardRef as ReactComponent };